import theme from './theme';
export const lightTheme = {
    cssVar: true,
    token: {
        colorPrimary: theme.colors.primary,
        fontFamily: 'Inter,-apple-system,San Francisco,PingFang SC,Noto sans SC,Microsoft YaHei;',
        wireframe: false,
    },
    components: {
        Card: {
            boxShadowTertiary: '0 1px 3px 0 #00000026, 0 0 .5px 0 #0000004d',
            borderRadiusLG: 12,
            paddingLG: 16,
        },
        Divider: {
            margin: 8,
            marginLG: 16,
            colorSplit: 'rgba(18,17,42,0.15)',
        },
        Input: {
            colorFillTertiary: 'rgba(0,0,0,0.07)',
            colorTextPlaceholder: '#00000080',
            borderRadius: 15,
        },
        Select: {
            colorFillTertiary: 'rgba(0,0,0,0.07)',
            colorTextPlaceholder: '#00000080',
        },
        InputNumber: {
            borderRadius: 15,
            lineHeight: 1.3,
            paddingBlock: 10,
            colorTextPlaceholder: 'rgb(85,85,85)',
            paddingInline: 15,
            colorText: 'rgb(85,85,85)',
            colorFillTertiary: 'rgba(0,0,0,0.07)',
            activeShadow: 'inset 0 0 0 2px hsla(129,60%,50%,1)',
        },
        Upload: {
            colorFillTertiary: 'rgba(0,0,0,0.07)',
            colorTextPlaceholder: '#00000080',
        },
        DatePicker: {
            colorFillTertiary: 'rgba(0,0,0,0.07)',
            colorTextPlaceholder: '#00000080',
        },
        Segmented: {
            trackBg: '#ededed',
        },
    },
};
